import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'mess_delete_dialog',
    templateUrl: 'mess_delete_dialog.component.html',
    styleUrls: ['mess_delete_dialog.component.scss']
})
export class MessDelete implements OnInit {
    objectKeys = Object.keys;
    courriers: any[];
    formats: any[];
    autreCourriers: any[];
    result: any = {
        selectedCourrier: {},
        selectedFormat: {}
    };
    courrierType: any[] = [];
    courrierAutre: any[] = [];

    constructor(
        public dialogRef: MatDialogRef<MessDelete>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
    }
    dismissDialog(){
        this.dialogRef.close({event:2});
    }
    deleteDossier(step){
        if(step === 2){
            this.dismissDialog();
        }else if(step === 3){
           this.dialogRef.close({event:step})
        }
    }
}